import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import ConfirmationMessage from '@/common/components/blocks/Modal/Common/ConfirmationMessage/ConfirmationMessage';
import { useAuth } from '@/common/contexts/AuthContext';
import { useModalContext } from '@/common/contexts/ModalContext';
import SessionStorageScanbat from '@/common/services/SessionStorage.scanbat';

const useCheckoutConfirm = () => {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const {
    setModalClassName,
    setModalContent,
    setModalIsOpen,
  } = useModalContext();

  const scanbatService = SessionStorageScanbat.getService();

  const onRemoveWarehouse = useCallback(() => {
    setModalContent(
      <ConfirmationMessage
        description={t('ebat:messages:actions.warehouse.clear.description')}
        onSubmit={() => {
          scanbatService.clearScanBat();
          logout();
        }}
        title={t('ebat:messages:actions.warehouse.clear.title')}
      />,
    );
    setModalClassName('modal-confirmation-message');
    setModalIsOpen(true);
  }, [
    logout,
    scanbatService,
    setModalClassName,
    setModalContent,
    setModalIsOpen,
    t,
  ]);

  return {
    onRemoveWarehouse,
  };
};

export default useCheckoutConfirm;
